import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useUserAuth } from "../context/UserAuthContext";
import Context from "../context/Context";
import backButton from "../assests/backButton.svg";
import Notifications from "../Components/Notifications/Notifications";
import Loading from "../Components/Loading/Loading";
import LoadingFromCenter from "../Components/LoadingFromCenter/LoadingFromCenter";
import { useNavigate, useParams } from "react-router";
import FloatingWidgets from "../Components/FloatingWidgets/FloatingWidgets";
import { createSearchParams } from "react-router-dom";

export default function NotificatinPage() {
  const [dataloading, setDataLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [notificationContents, setNotificationContents] = useState([]);
  const [newNotifications, setNewNotifications] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const { verifyUser, userIdToken, preview, details, isMobile } =
    useContext(Context);
  const { currentUser, previousLocation, searchParams } = useUserAuth();
  const [newNotificationFound, setNewNotificationsFound] = useState(false);
  const [userId, setUserId] = useState(undefined);
  const [viewArrayEqual, setViewArrayEqual] = useState(false);
  const { organizerName } = useParams();
  const campaignUniqueText = useParams().campaignUniqueText?.replace(
    /\.html$/,
    ""
  );
  useEffect(() => {
    verifyUser();
    if (currentUser) {
      newNotificationCheck();
    }
  }, []);
  const navigate = useNavigate();
  const token = userIdToken || currentUser?.accessToken;
  //get status of notification
  const newNotificationCheck = () => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_NOTIFICATION_STATUS_CHECKER}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }).then((response) => {
      setUserId(response?.data?.data?.userId);
      setNewNotificationsFound(response?.data?.data?.newNotificationFound);
    });
  };
  const newNotificationsFilter = notificationContents?.filter((item) => {
    const foundItem = newNotifications?.find(
      (idObj) => idObj?.id === item?._id
    );
    return foundItem;
  });
  const viewNotifications = () => {
    if (
      newNotificationFound &&
      userId !== undefined &&
      newNotificationsFilter?.length === newNotifications?.length &&
      !viewArrayEqual
    ) {
      axios({
        method: "PATCH",
        url: `${process.env.REACT_APP_VIEW_NOTIFICATION}/${userId}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }).then((response) => {});
      setViewArrayEqual(true);
    }
  };
  //get notification with pagenation
  const observer = useRef();
  const lastElementRef = useCallback(
    (node) => {
      if (dataloading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [dataloading, hasMore]
  );
  useEffect(() => {
    setDataLoading(true);
    let cancel;
    let url = `${process.env.REACT_APP_GET_NOTIFICATION}/${userId}?page=${pageNumber}&limit=10`;
    axios({
      method: "get",
      url: url,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      cancelToken: new axios.CancelToken((c) => (cancel = c)),
    })
      .then((res) => {
        setNewNotifications(res?.data?.data?.newNotifications);
        setNotificationContents((prevContestData) => {
          const newNotifications = Array.isArray(res?.data?.data?.notifications)
            ? res.data.data.notifications
            : [];
          return [...new Set([...prevContestData, ...newNotifications])];
        });
        setHasMore(res?.data?.data?.notifications?.length > 0);
        setDataLoading(false);
      })
      .catch((e) => {
        if (axios.isCancel(e)) return;
        setDataLoading(false);
      });

    return () => cancel();
  }, [pageNumber]);

  const excludeNew = (idToCheck) => {
    const check = newNotifications?.some((obj) => obj.id === idToCheck);
    return check;
  };
  const handleNavigateToPrevLocation = () => {
    viewNotifications();
    if (previousLocation) {
      if (preview) {
        navigate({
          pathname: previousLocation,
          search: "?preview=true",
        });
      } else {
        navigate({
          pathname: previousLocation,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        });
      }
    } else if (organizerName && campaignUniqueText) {
      if (preview) {
        navigate({
          pathname: `/${organizerName}/${campaignUniqueText}`,
          search: "?preview=true",
        });
      } else {
        navigate({
          pathname: `/${organizerName}/${campaignUniqueText}`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        });
      }
    } else {
      navigate({
        pathname: `/`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      });
    }
  };
  return (
    <div className="widthController ">
      <FloatingWidgets page="notification" endTime={details?.endDate} />
      <div className="flex gap-[10px] items-center py-[12px] px-[20px] sticky top-0 header-bg">
        {/* {!isMobile && ( */}
        <div
          className="w-[40px] h-[40px] rounded-full flex items-center justify-center cursor-pointer"
          onClick={handleNavigateToPrevLocation}
        >
          <img src={backButton} />
        </div>
        {/* )} */}
        <p className="text-large">Notifications</p>
      </div>
      {/* {newNotificationsFilter?.length > 0 && (
        <p className="text-regular-bold">New</p>
      )} */}
      <div className="px-[20px]">
        {newNotificationsFilter?.map((notification) => {
          return (
            <div>
              <Notifications
                notification={notification}
                status="NEW"
                token={token}
              />
              <div className="seperator" />
            </div>
          );
        })}

        {/* <p className="text-regular-bold mt-[20px]">Old</p> */}

        {notificationContents?.map((notification, index) => {
          if (notificationContents?.length === index + 1) {
            return (
              <div ref={lastElementRef}>
                {!excludeNew(notification?._id) && (
                  <div>
                    <Notifications notification={notification} token={token} />
                    <div className="seperator" />
                  </div>
                )}
              </div>
            );
          } else {
            if (!excludeNew(notification?._id)) {
              return (
                <div>
                  <Notifications notification={notification} token={token} />
                  <div className="seperator" />
                </div>
              );
            }
          }
        })}
        {dataloading && (
          <div className="w-[100%] flex justify-center">
            <div className="w-[20px]">
              <LoadingFromCenter />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
